var _circle, _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyCards(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 90,
    r: 90,
    fill: "#C6E7F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.674 131.386L161.874 110.86C165.216 110.249 167.43 107.045 166.818 103.703L155.131 39.8346C154.519 36.4933 151.315 34.2801 147.973 34.8916L35.772 55.4169C32.4302 56.0284 30.2167 59.2324 30.8282 62.5737L42.5156 126.443C43.1271 129.784 46.3322 131.997 49.674 131.386Z",
    fill: "#5CFFE9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4498 52.5484C59.4495 56.9747 68.8404 60.6517 78.6221 61.2643C105.501 62.9489 116.918 50.8127 146.843 54.6814C150.915 55.2077 154.722 56.0466 158.288 57.0818L163.298 84.4646C156.767 79.5703 147.614 74.4676 135.82 71.9949C109.393 66.4545 98.3109 76.2565 74.4417 72.8473C60.2796 70.8247 47.6186 61.7507 39.6626 54.705L51.4498 52.5484Z",
    fill: "#40B0D5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M156.945 49.7481C155.891 49.4741 154.822 49.2124 153.722 48.982C127.295 43.4416 116.213 53.2436 92.3437 49.8344C88.6869 49.3121 85.1321 48.3162 81.7303 47.0099L147.285 35.0177C151.007 34.3367 154.577 36.8015 155.258 40.5234L156.945 49.7481Z",
    fill: "#40B0D5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 57.8015,
    y: 102.785,
    width: 14.7455,
    height: 5.8982,
    transform: "rotate(-10.1559 57.8015 102.785)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 44.8518,
    y: 114.121,
    width: 14.7455,
    height: 5.8982,
    transform: "rotate(-10.1559 44.8518 114.121)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 51.8572,
    y: 111.414,
    width: 14.7455,
    height: 5.8982,
    transform: "rotate(-100.156 51.8572 111.414)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 63.166,
    y: 124.369,
    width: 14.7455,
    height: 5.8982,
    transform: "rotate(-100.156 63.166 124.369)",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M118.537 134.121L85.6389 101.613L79.1245 108.205L112.023 140.714L118.537 134.121Z",
    fill: "#00465D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M131.105 142.856L105.509 117.565C105.367 117.424 105.137 117.425 104.997 117.568L95.3089 127.372C95.1681 127.514 95.1695 127.744 95.312 127.885L120.907 153.176C121.05 153.317 121.279 153.315 121.42 153.173L131.108 143.369C131.249 143.226 131.247 142.997 131.105 142.856Z",
    fill: "#1688AE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.4621 76.981C97.4621 99.6142 79.1142 117.962 56.481 117.962C33.8478 117.962 15.5 99.6142 15.5 76.981C15.5 54.3478 33.8478 36 56.481 36C79.1142 36 97.4621 54.3478 97.4621 76.981ZM90.7749 76.9811C90.7749 95.9213 75.4209 111.275 56.4807 111.275C37.5406 111.275 22.1865 95.9213 22.1865 76.9811C22.1865 58.0409 37.5406 42.6869 56.4807 42.6869C75.4209 42.6869 90.7749 58.0409 90.7749 76.9811Z",
    fill: "#1688AE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M56.4807 111.275C75.4209 111.275 90.7749 95.9213 90.7749 76.9811C90.7749 58.0409 75.4209 42.6869 56.4807 42.6869C37.5406 42.6869 22.1865 58.0409 22.1865 76.9811C22.1865 95.9213 37.5406 111.275 56.4807 111.275Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCards);
export default __webpack_public_path__ + "static/media/empty-cards.d391f15fb766321f3415412cd47468f5.svg";
export { ForwardRef as ReactComponent };